import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { errorMessage } from '@/lib/http';
import { createChat } from './api';
import { useStreamStore, type SendInput } from './streamStore';

export function useChatActions() {
  const qc = useQueryClient();
  const navigate = useNavigate();
  const store = useStreamStore();

  /** Create a chat, open it, then stream the first turn. */
  const sendNew = useCallback(
    async (input: SendInput) => {
      try {
        const chat = await createChat(qc);
        navigate(`/c/${chat.chatId}`);
        void store.send(chat.chatId, input);
      } catch (err) {
        toast.error(errorMessage(err, 'Could not start a new chat.'));
      }
    },
    [qc, navigate, store],
  );

  return { sendNew };
}
